import React, { useState } from 'react';
import { Animated, Pressable, View } from 'react-native';
import { Icon } from '@/components/Icon';
import { Card } from '@/components/ui/therapist/Card';
import RadioButton from '@/components/ui/therapist/RadioButton';
import { Text } from '@/components/ui/therapist/Text';
import colors from '@/config/colors';
import { useRotateAnimation } from '@/hooks/useRotateAnimation';
import { styles } from './styles';

type CardTemplateProps = {
  description?: string;
  descriptionBodySection?: () => React.ReactNode;
  footerSection?: () => React.ReactNode;
  isSelected?: boolean;
  name: string;
  onSelect?: () => void;
  pillsSection?: () => React.ReactNode;
  headerBackground?: () => React.ReactNode;
};

export const CardTemplate: React.FC<CardTemplateProps> = ({
  description,
  descriptionBodySection,
  footerSection,
  isSelected = false,
  name,
  onSelect,
  pillsSection,
  headerBackground,
}) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const rotate = useRotateAnimation(expanded, 200);

  return (
    <Card
      styleBody={[
        styles.cardBody,
        isSelected ? { borderColor: colors.newUI.therapist.blue60 } : null,
      ]}
    >
      <Pressable onPress={() => (onSelect ? onSelect() : null)}>
        <View style={styles.headerWrapper}>
          {headerBackground ? headerBackground() : null}
          <View
            style={
              onSelect
                ? { flexDirection: 'row', alignItems: 'flex-start', gap: 8 }
                : null
            }
          >
            {onSelect ? (
              <RadioButton onPress={() => onSelect()} isSelected={isSelected} />
            ) : null}
            <View style={{ flex: 1 }}>
              <Text style={styles.title}>{name}</Text>
              {description ? (
                <Pressable
                  onPress={() => setExpanded((p) => !p)}
                  style={styles.detailsRow}
                >
                  <Text style={styles.detailsText}>Details einblenden</Text>
                  <Animated.View style={{ transform: [{ rotate }] }}>
                    <Icon
                      name="chevronDown"
                      size={24}
                      color={colors.newUI.therapist.primaryBlue80}
                    />
                  </Animated.View>
                </Pressable>
              ) : null}
              {expanded ? (
                <View style={[styles.descriptionWrapper]}>
                  <Text style={{ color: colors.newUI.therapist.primaryBlue80 }}>
                    {description}
                  </Text>
                  {descriptionBodySection?.()}
                </View>
              ) : null}
            </View>
          </View>
        </View>
      </Pressable>
      {pillsSection ? (
        <View style={styles.pillWrapper}>{pillsSection()}</View>
      ) : null}
      {footerSection?.() ? (
        <View
          style={[
            styles.actionsRow,
            !pillsSection && !description ? { borderTopWidth: 0 } : null,
          ]}
        >
          {footerSection()}
        </View>
      ) : null}
    </Card>
  );
};
